import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';







import { EVFunctions } from '@configs/base-functions';
import { authRoutes } from './auth/auth.routes';
import { authGuard } from './auth/auth.guard';
export const routes: Routes = [
  { path: 'login', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'help',
    data: { title: 'Jupiter Help' },
    loadComponent: () => import('./admin-help/admin-help.component'),
  },
  { path: 'auth', children: authRoutes },
  {
    path: '',
    canActivateChild: [authGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'dashboard/faq/view', loadComponent: () => import('./FAQ/dashboard-faq-view/dashboard-faq-view.component').then(m => m.DashboardFaqViewComponent) },
      { path: 'dashboard/faq/admin', loadComponent: () => import('./FAQ/dashboard-faq-admin/dashboard-faq-admin.component').then(m => m.DashboardFaqAdminComponent) },
      { path: 'dashboard/faq/admin/create', loadComponent: () => import('./FAQ/dashboard-faq-create-new/dashboard-faq-create-new.component').then(m => m.DashboardFaqCreateNewComponent) },
      {
        path: 'cms',
        loadChildren: () =>
          import('projects/evolutics-shared-lib/src/lib/Reusables/reusable-pages/cms/cms.routes'),
      },
      {
        path: '',
        loadComponent: () => import('@Layout/form-layout/form-layout.component').then(m => m.FormLayoutComponent),
        children: [
          { path: 'api', loadChildren: () => import('./API/API.module').then((m) => m.APIModule) },
          { path: 'api/show/client', loadComponent: () => import('./API/pages/client-view-api/client-view-api.component').then(m => m.ClientViewApiComponent) },
          {
            path: 'setup',
            title: 'Setup',
            loadChildren: () => import('./Setup/setup.module').then((m) => m.SetupModule),
          },
          { path: 'faq', loadChildren: () => import('./FAQ/FAQ.module').then((m) => m.FAQModule) },
          { path: 'db', loadChildren: () => import('./DB/DB.module').then((m) => m.DBModule) },
          {
            path: 'analytics',
            loadChildren: () => import('./Analytics/Analytics.module').then((m) => m.AnalyticsModule),
          },
          { path: 'task', loadChildren: () => import('./Tasks/Tasks.module').then((m) => m.TasksModule) },
          {
            path: 'admin',
            children: [
              {
                path: 'user',
                loadChildren: () =>
                  import('./Admin/user/user-pages/create-user/create-user.module').then(
                    (m) => m.CreateUserModule,
                  ),
              },
              {
                path: 'userGroup',
                children: EVFunctions.extendRoute(
                  {
                    path: 'group',
                    loadChildren: () =>
                      import('./Admin/adminusergroup/adminusergroup.module').then(
                        (m) => m.AdminusergroupModule,
                      ),
                    data: { title: 'Admin / User Group' },
                  },
                  null,
                  () =>
                    import('./Admin/adminusergroup/adminusergroup.module').then(
                      (m) => m.AdminusergroupModule,
                    ),
                ),
              },
              {
                path: 'company',
                loadChildren: () => import('./company/company.module').then((m) => m.CompanyModule),
              },
              {
                path: 'menus',
                loadChildren: () => import('./Admin/usermenu/usermenu.module').then((m) => m.UsermenuModule),
              },
              {
                path: 'release',
                loadChildren: () => import('./Admin/release/release.module').then((m) => m.ReleaseModule),
              },
              {
                path: 'suggestion',
                loadChildren: () =>
                  import('./Admin/suggestion/suggestion.module').then((m) => m.SuggestionModule),
              },
              {
                path: 'project',
                loadChildren: () => import('./project/project.module').then((m) => m.ProjectModule),
              },
            ],
          },
          { path: 'company', redirectTo: 'admin/company' },
          { path: 'suggestion', redirectTo: 'admin/suggestion' },
          { path: 'project', redirectTo: 'admin/project' },
          {
            path: 'application',
            loadChildren: () => import('./application/application.module').then((m) => m.ApplicationModule),
          },
          {
            path: 'reports',
            loadChildren: () =>
              import('@Reusables/reusable-pages/Report/report.module').then((m) => m.ReportModule),
          },
          {
            path: 'home',
            loadComponent: () => import('@Layout/dashboard-admin/dashboard-admin.component').then(m => m.DashboardAdminComponent),
            loadChildren: () => import('./Home/home.module').then((m) => m.HomeModule),
          },
          {
            path: 'profile',
            children: [
              {
                path: '',
                data: { title: 'Profile' },
                loadComponent: () => import('./profile/profile.component').then((c) => c.ProfileComponent),
              },
            ],
          },
          {
            path: 'suggestions',
            loadChildren: () =>
              import('./Admin/suggestion/suggestion.module').then((m) => m.SuggestionModule),
          },
        ],
      },
      {
        path: 'client',
        loadChildren: () => import('./client-view/client-view.module').then((m) => m.ClientViewModule),
      },
      {
        path: 'client-libraries',
        loadChildren: () =>
          import('./client-libraries/client-libraries.module').then((m) => m.ClientLibrariesModule),
      },
      {
        path: 'client-home',
        loadComponent: () => import('@Layout/dashboard-client-admin/dashboard-client-admin.component').then(m => m.DashboardClientAdminComponent),
        loadChildren: () => import('./Client-Home/client-home.module').then((m) => m.ClientHomeModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('@Reusables/reusable-pages/extra-pages/extra-pages.module').then((m) => m.ExtraPagesModule),
      },
    ],
  },
];
@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule {}
